import { loadRawRemoteFile } from '../remote-storage/tasks';
import { IAnimationsCache } from './rLottie.types';

export const loadLottieFile = async (
  url: string,
  animationsCache: IAnimationsCache
): Promise<Record<string, any> | null> => {
  try {
    const response = await loadRawRemoteFile(url);
    if (!response.ok) {
      return null;
    }

    const lottieData = (await response.json()) as Record<string, any>;
    await animationsCache.putLottieObject(url, lottieData);

    return lottieData;
  } catch {
    return null;
  }
};
